import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgxToastrService } from '@core/services';
import { WalletService } from '@core/services/wallet.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'app-view-pdf-modal',
  templateUrl: './view-pdf-modal.component.html',
  styleUrls: ['./view-pdf-modal.component.scss'],
})
export class ViewPdfModalComponent implements OnInit {
  @Input() blobUrl: string | null = null;
  @Input() blobUrls: string[] = [];
  @Input() fileName: string | null = null;
  @Input() fileNames: string[] = [];
  currentIndex: number = 0;
  tempBlobUrl: string | null = null;
  isViewerVisible: boolean = true;
  @Input() bookedUuid: string | null = null;
  @Input() bookedType: any = null;
  loadingWalletLink: boolean = false;
  loadingAppleLink: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private walletService: WalletService,
    private ngxToastrService: NgxToastrService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.blobUrls.reverse()
    this.tempBlobUrl = this.currentBlobUrl;
  }

  get currentBlobUrl(): string {
    return this.blobUrls.length > 0
      ? this.blobUrls[this.currentIndex]
      : this.blobUrl!;
  }

  get currentFileName(): string {
    return this.fileNames.length > 0
      ? this.fileNames[this.currentIndex]
      : this.fileName || '';
  }

  next() {
    if (this.currentIndex < this.blobUrls.length - 1) {
      this.currentIndex++;
      this.refreshPdfViewer();
    }
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.refreshPdfViewer();
    }
  }

  refreshPdfViewer() {
    this.isViewerVisible = false;
    this.cdr.detectChanges();

    this.tempBlobUrl = this.currentBlobUrl;
    this.isViewerVisible = true;
    this.cdr.detectChanges();
  }

  downloadPDFBooked() {
    window.open(this.currentBlobUrl, '_blank');
  }

  private showToast(
    kind: 'success' | 'info' | 'error',
    titleKey: string,
    message?: string,
    params?: Record<string, any>
  ) {
    this.translate.get(titleKey, params).pipe(take(1)).subscribe(title => {
      switch (kind) {
        case 'success': this.ngxToastrService.typeSuccess(title, message); break;
        case 'info':    this.ngxToastrService.typeInfo(title, message);    break;
        case 'error':   this.ngxToastrService.typeError(title, message);   break;
      }
    });
  }

  addToGoogleWallet() {
    if (!this.bookedUuid || !this.bookedType || this.loadingWalletLink) return;
    this.loadingWalletLink = true;

    this.walletService
      .getWalletLink(this.bookedType, this.bookedUuid)
      .pipe(finalize(() => (this.loadingWalletLink = false)))
      .subscribe({
        next: (res: { created?: boolean; updated?: boolean; jwt?: string; saveUrl?: string | null; objectId?: string; classId?: string }) => {
          if (typeof res?.saveUrl === 'string' && res.saveUrl.startsWith('https://pay.google.com/gp/v/save/')) {
            window.open(res.saveUrl, '_blank', 'noopener');
            this.showToast('success', 'my-bookeds.view.wallet.toast.opening');
            return;
          }

          if (res?.updated) {
            this.showToast('success', 'my-bookeds.view.wallet.toast.updated');
            return;
          }

          if (res?.created && !res?.saveUrl) {
            this.showToast('info', 'my-bookeds.view.wallet.toast.created_no_url');
            return;
          }

          this.showToast('info', 'my-bookeds.view.wallet.toast.no_change');
        },
        error: (err) => {
          const serverMsg = err?.error?.message || err?.message || '';
          this.showToast('error', 'my-bookeds.view.wallet.toast.error_title', serverMsg);
        },
      });
  }

  addToAppleWallet() {
      if (!this.bookedUuid || !this.bookedType || this.loadingAppleLink) return;

      this.loadingAppleLink = true;

      this.walletService.getApplePkpass(this.bookedType, this.bookedUuid)
        .pipe(finalize(() => {
          this.loadingAppleLink = false;
          this.cdr.markForCheck();
        }))
        .subscribe({
          next: (resp) => {
            const blob = resp.body as Blob;
            const cd = resp.headers.get('Content-Disposition') || '';
            const m = /filename="?([^"]+)"?/i.exec(cd);
            const filename = m?.[1] || `vyootrip-${this.bookedType}.pkpass`;

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 30000);

            this.showToast('success', 'my-bookeds.view.wallet.toast.downloaded-apple-wallet');
          },
          error: (err) => {
            const serverMsg = err?.error?.message || err?.message || '';
            this.showToast('error', 'my-bookeds.view.wallet.toast.error-apple-wallet', serverMsg);
          }
        });
    }
  
  
  closeModal() {
    this.activeModal.dismiss('Cross click');
  }
}
